import { Box, MenuItem, InputBase, Select, FormControl, OutlinedInput } from "@mui/material";
import { useStockControlStore } from "../../hooks/useStockControlStore";
import { useControlStockSelectivo } from "../../helpers/useControlStockSelectivo";
import FormularioBase from "./FormularioBase";
import ArticuloSelector from "./ArticuloSelector";

const FormularioSelectivo = ({ mostrarTipoControl = true, tituloAlternativo }) => {
  const { articuloActual, setStockReal } = useStockControlStore();

  const { seleccionarArticulo, guardarYResetear, finalizarControl, articulosDisponibles, articulosSeleccionados, loading } = useControlStockSelectivo();

  // Campos personalizados para el formulario selectivo
  const camposPersonalizados = (
    <ArticuloSelector
      articuloActual={articuloActual}
      articulosDisponibles={articulosDisponibles}
      articulosSeleccionados={articulosSeleccionados}
      onSeleccionarArticulo={seleccionarArticulo}
      loading={loading}
    />
  );

  return (
    <FormularioBase
      mostrarTipoControl={mostrarTipoControl}
      tituloAlternativo={tituloAlternativo}
      camposPersonalizados={camposPersonalizados}
      onProximo={guardarYResetear}
      onInexistente={() => {
        setStockReal(0);
        guardarYResetear();
      }}
      onNoControlar={finalizarControl}
      loading={loading}
    />
  );
};

export default FormularioSelectivo;
